import { createAction } from '@reduxjs/toolkit';

export const toastrUpdateIsShow = createAction('toastr/updateIsShow');
export const toastrUpdateMessage = createAction('toastr/updateMessage');
export const toastrUpdateType = createAction('toastr/updateType');
// Same reason as `toastrDismiss` below: a bare createAction() infers a payloadless creator, so the
// message argument would not type-check in TS callers.
/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<string>} */
export const toastrShowSuccess = createAction('toastr/showSuccess');
/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<string>} */
export const toastrShowError = createAction('toastr/showError');
/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<string>} */
export const toastrShowInfo = createAction('toastr/showInfo');
// Typed for the TS consumers (`Toastr.tsx`) — inference from a bare `createAction()` call in a .js
// module gives a payloadless creator, and the toast id would not type-check.
/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<number>} */
export const toastrDismiss = createAction('toastr/dismiss');
